export const habaUser = {
  habaCommonUserInformation: {
    nameAndJob: '{{firstName}} {{lastName}}, {{job}}',
    profileImageAlt: 'Profile image of the user',
  },
  habaLoginForm: {
    heading: 'Welcome back',
    checkoutHeading: 'I am already a customer in the online shop',
    newCustomer: 'I am a new customer in the online shop',
    next: 'Continue',
    forgotPassword: 'Forgot password?',
    signIn: 'Sign In',
    register: 'Register now',
    dontHaveAccount: 'Don’t have an account?',
    emailAddress: {
      label: 'Email address',
      wrongEmailFormat: 'This is not a valid email format.',
    },
    password: {
      label: 'Password',
      passwordRequired:
        'At least 6 characters, at least one special character, at least one uppercase letter, at least one lowercase letter, at least one number',
    },
    guestCheckout: 'Guest Checkout',
    successfulLogin: 'Welcome! Login successful',
    failedLogin:
      "Unfortunately, that didn't work. Please check if you are using the correct email address and password.",
    passwordExpired:
      '<strong>Your password has expired.</strong><br />Please <a href="{{url}}">reset your password</a> to be able to log in.',
    reminderEmail: {
      title: 'Email not confirmed!',
      description:
        '<strong>You have not confirmed your email address. To log in,</strong> please confirm your email address so we can create your account. We have sent you an email. Just click on the confirmation link in the email.<br/><br/>If you did not receive an email, please check your spam folder or request a new email.',
      resendEmail: 'Resend email',
      infoTitle: 'Note:',
      infoText:
        "Please note that the link in the received email is <strong>only available for 2 hours</strong>.<br/>br/>If you do not confirm your email address, <strong>your account will be deleted in 2 weeks</strong> from the time of account registration. So don't forget to click on the confirmation link.<br/>br/><strong>3 days</strong> before the account is deleted, you will receive a reminder email with a link to request a new confirmation email.",
      activationLinkSent: 'Activation email sent successfully.',
      activationLinkError:
        'An error occurred while sending the activation email. Please try again later.',
    },
  },
  habaRegisterForm: {
    heading3: 'Registration',
    heading2: 'Billing address',
    heading: 'Welcome',
    headingCheckout: 'Order as a new or guest customer',
    orderAsGuestText: 'I want to order as a guest',
    register: 'Register now',
    registerAsGuest: 'For guest ordering',
    invoiceNotPossible: 'For a guest order, payment by invoice is not possible.',
    emailAddress: {
      label: 'Email address',
      wrongEmailFormat: 'This is not a valid email format.',
      userAlreadyExists:
        'A customer account already exists for this email address. Please log in to continue ordering.',
    },
    password: {
      label: 'Password',
      passwordRequired:
        'Password must be six characters minimum, with one uppercase letter, one number, one symbol',
      placeholder:'Please choose a password'
    },
    passwordRepeat: {
      label: 'Confirm password',
      passwordRequired: "Passwords don't match",
    },
    postRegisterMessage: 'Registration successful! Please log in with provided credentials',
    firstName: {
      label: 'First Name',
      required: 'Mandatory field',
    },
    lastName: {
      label: 'Last Name',
      required: 'Mandatory field',
    },
    hasAccount: 'Do you already have a customer account?',
    hasAccountLink: 'Sign up here',
  },
  habaNavLogin: {
    login: 'Login',
    register: 'Register',
    logoutLink: 'Logout',
    logout: 'Not {{name}}?',
    successfulLogout: 'Logout successful.',
    modal: {
      headline: 'My account',
    },
    myAccount: {
      overview: 'Overview',
      orders: 'Orders',
      accountData: 'Account Information',
      deliveryAddresses: 'My delivery addresses',
    },
  },
  habaForgottenPassword: {
    heading: 'Reset password',
    headingNewPassword: 'Assign new password',
    save: 'save',
    newPassword: 'New password',
    confirmPassword: 'Confirm password',
    checkInbox: 'Please check your email inbox…',
    instructions:
      'Password reset instructions have been sent to your email address. Please contact customer service if you need further assistance',
    errorMessage: 'An error has occurred. Please try again later.',
    tokenExpired: 'Your token has expired. Please request a new Forgot Password email.',
    successFullUpdated: 'Your password has been updated',
    information: 'Please enter your e-mail address',
    emailAddress: {
      label: 'Email address',
      wrongEmailFormat: 'This is not a valid email format.',
    },
    submit: 'submit',
    cancel: 'cancel',
    infoText: {
      forgotPassword:
        'Please use the email address you used to register your account. <br/> We will then send you a link that you can use to create a new password.',
      resetMailSend: {
        firstPart:
          'If a user account exists for the email address you entered, we have sent an email to reset your password to <b>{{ emailAddress }}</b>.',
        secondPart: 'Please follow the link in the email to set a new password.',
      },
      noEmailInfo: {
        headline: "Didn't receive a message?",
        reason1: 'Check whether the email address was entered correctly.',
        reason2: 'Check your spam folder.',
        newUser: 'If no user account exists for this email address, you can',
        newUserLinkText: 'create a new user account here.',
        backToAccount: 'Back to login',
      },
      resetPassword:
        'To keep your account secure, your password must contain at least the following characters:',
    },
  },
  habaProRegisterForm: {
    deviatingEmailData: {
      headline: 'Deviating Invoice Recipient Email (optional)',
      label: 'Deviating email address for this invoice',
      disclaimer:
        'We will send the invoice to the email address specified here. Other emails regarding the order process (order confirmation, etc.) will be sent as usual to your email address.',
    },
    buttons: {
      cartOfferButton: 'Request Offer',
      nextRegisterPage: 'register now',
      next: 'next',
      updateRegistration: 'Edit billing address',
      submit: 'Register now',
      goToDeliveryStep: 'Continue to delivery address',
      goToPaymentStep: 'Continue to payment method',
    },
    sponsorData: {
      name: 'Name*',
      nameExtension: 'Name extension (optional)',
      headerline: 'Sponsor informations',
      sponsorDataAccordion: 'Sponsor data (optional)',
      disclaimer:
        'Please enter the complete information of your sponsor so we can connect you to your sponsor.',
    },
    form: {
      customerType: {
        private: 'Private',
        firm: 'Company',
        institution: 'Institution',
        select: 'In which role do you order?',
        firmSelected: 'The bill is paid by a company',
        institutionSelected: 'The bill is paid by an institution or a company.',
        privateSelected: 'The bill is paid by me or another private individual.',
      },
      gtc: 'Ich erkenne die Datenschutzerklärung sowie die AGB von Wehrfritz an. Sie haben per Gesetz ein 14-tägiges Widerrufsrecht. Einzelheiten und Ausnahmen dazu in unserer Widerrufsbelehrung.',
      disabledFieldsError: 'Please make a choice',
    },
    industrySelection: {
      nurseryDay: 'Day nursery',
      dayCare: 'Day nursery/daycare',
      dayCareCenter: 'day care centers',
      district: 'district',
      city: 'city',
      therapists: 'therapists',
      socialWards: 'Social services/outpatient care',
      retirement: 'Retirement home',
      medicalPractice: 'Medical practices',
      supportAssociation: 'Daycare/school booster club',
      afterSchoolCare: 'After school care',
      pupilCare: 'Pupil care',
      elementarySchool: 'Elementary school',
      specialSchool: 'Special school',
      comprehensiveSchool: 'Comprehensive school',
      middleSchool: 'Middle school',
      secondarySchool: 'Secondary school',
      highSchool: 'High school',
      otherSchool: 'Other Schools',
      other: 'Other',
    },
    formError: {
      gtc: 'Please accept the terms and conditions.',
      phoneNumberFormat: 'Format: +4912345678',
      zipCodeLength: 'The zip code must be {{length}} digits.',
    },
    messages: {
      postRegisterMessage:
        '<b>Please confirm your e-mail address, then we can create your account.</b><br/>We have sent you an e-mail. Just click on the confirmation link in the e-mail.',
      userAlreadyExists: 'User already exists.',
      unexpectedError: 'Oops, something went wrong here',
      updateAddress: 'Address has been updated.',
    },
  },
  habaAccountOverview: {
    personalProfile: 'Persönliches Profil',
    personalProfileMessage:
      'Dies ist dein persönliches {{ storeName }} Profil, hier findest du alle wichtigen Informationen und jede Menge Inspirationen!',
    pageTitle: 'Welcome to your account',
    pageDescription: '',
    customerType: {
      institution: 'Institution',
      carrier: 'Carrier',
      association: 'Association',
      company: 'Company',
      private: 'Private customer',
    },
    card: {
      orders: {
        title: 'My orders',
        text: 'Open your placed orders here.',
        btnText: 'To the order overview',
      },
      wishlist: {
        title: 'My wishlists',
        text: 'Open and edit your preregistered products here.',
        btnText: 'To the wishlists',
      },
      customerData: {
        title: 'My customer data',
        text: 'Edit your personal customer data here.',
        btnText: 'To the customer data',
      },
      delivery: {
        title: 'My delivery addresses',
        text: 'Edit your shipping addresses here.',
        btnText: 'To the delivery addresses',
      },
    },
  },
  habaCustomerData: {
    authorizationGroup: {
      trigger: 'Why can I not change this data?',
      notice: 'Die Kundendaten können nur in Absprache mit dem Kundenservice geändert werden.',
      serviceHoursTitle: 'Unsere Servicezeiten',
      serviceDays: 'Montag bis Freitag:',
      serviceTime: '8:00 Uhr bis 16:00 Uhr',
    },
    pendingSapEnrichment: {
      trigger: 'Why can I not change this address?',
      title: 'This address is still being processed',
      notice:
        'The address is currently being created in our system. It can be changed again as soon as that is complete.',
    },
    loginData: {
      changeEmailAndSave: 'Change e-mail & save',
      changeLoginData: 'Change login data',
      changeError: 'Please make sure you use the correct password.',
      changePasswordAndSave: 'Change password & save',
      confirmNewEmail: 'Confirm new e-mail address',
      confirmNewPassword: 'Confirm password',
      currentEmail: 'Current e-mail address:',
      currentPassword: 'Current password',
      currentPasswordRequired: 'Please enter your yurrent password.',
      emailsMustMatch: 'E-mail addresses must match.',
      invalidEmail: 'Please enter a valid e-mail address.',
      newEmail: 'New e-mail address',
      newPassword: 'New password',
    },
    deliveryAddress: {
      globalMessage: {
        updated: 'Delivery address updated',
        added: 'Delivery address added',
      },
      list: {
        headline: 'My delivery addresses',
        phoneNumber: 'Phone',
        btn: {
          new: 'Add new delivery address',
          newMobile: 'New delivery address',
          delete: 'Delete',
          edit: 'Edit',
        },
        defaultDeliveryAddress: 'Default delivery address',
        isBillingAddress: 'Billing address',
      },
      new: {
        headline: 'Add new delivery address',
        btn: {
          add: 'Add',
          cancel: 'Back without change',
        },
      },
      edit: {
        headline: 'Edit delivery address',
        btn: {
          update: 'Update',
          cancel: 'Back without change',
        },
      },
      modal: {
        headline: 'Remove shipping address?',
        pendingOrder: 'Pending orders addressed to this location will not be canceled.',
        btn: {
          cancel: 'Cancel',
          delete: 'Delete',
        },
      },
      invoiceDownload: {
        headline: 'Invoice request',
        part1Headline: '1. Do you have your invoice number at hand?',
        part1Description:
          'Simply download it here. Enter your customer number and invoice number in the input fields below and click Download.<br/>For data protection reasons, the system checks in the background whether the customer number and invoice number belong together - only then is downloading possible.<br/>You can only download one invoice at a time. For multiple invoices, you must perform these steps one after another.',
        part2Headline: '2. Do you only have the order number available?',
        part2Description:
          'Enter your customer number and order number in the input fields below and click Download.<br/>For data protection reasons, the system checks in the background whether the customer number and order number belong together - only then is downloading possible.<br/>You can find both details (customer and order number) on the order confirmation sent to you in advance.<br/>All invoices available for the specified order will be displayed.',
        inputCustomerNr: 'Business Partner / Customer Number',
        inputInvoiceNr: 'Document Number / Invoice Number or Order Number',
        inputCustomerNrError: 'The customer number must be provided.',
        inputInvoiceNrError: 'The invoice number must be provided.',
        submitButton: 'Download invoice',
        notFound:
          'An invoice for the specified customer number and invoice number could not be found.',
      },
      orderStatus: {
        inputError: 'Providing a number is necessary',
        customerNrFormatError:
          'The customer number may contain a maximum of 10 digits and must consist only of numbers',
        headline: 'Order status / delivery status',
        info: 'Dear customer, you can use this query to check the delivery status of your order. Please note that in order to display the data we need the correct combination of the customer and order number associated with the order. For orders with many items, the query can take a second. Please be patient for a moment.',
        inputText: 'Enter your customer number and order number',
        customerNumberText: 'Customer number / business partner number',
        orderNumberText: 'Order number',
        submitText: 'View order status',
        startsWithNineAndTenDigits: 'The order number starts with a 9 and has 10 digits',
        onlyDigits: 'The order number consists only of digits',
      },
    },
    billingAddress: {
      subtitle: 'You can choose from these billing addresses when making a purchase',
      defaultBillingAddress: 'Default billing address',
      addNew: 'Add new billing address',
      new: {
        headline: 'Add billing address',
        btn: {
          add: 'Add',
          cancel: 'Back without change',
        },
      },
      edit: {
        headline: 'Edit billing address',
        btn: {
          update: 'Update',
          cancel: 'Back without change',
        },
      },
    },
    overview: {
      address: 'Address',
      billingAddress: 'Billing address',
      emailAddress: 'E-mail address',
      loginData: 'Login data',
      myData: 'My data',
      name: 'Name',
      noBillingAddress: "You don't have a billing address yet",
      password: 'Password',
      personalData: 'Personal data',
      phoneNumber: 'Phone number',
    },
    updateData: {
      headline: 'Personal data',
      updateButton: 'update personal data',
      successMessage: 'updated personal data successfully',
    },
  },
  habaOrderHistory: {
    myOrders: 'Meine Bestellungen',
    orderFrom: 'Bestellung vom',
    orderNumber: 'Auftragsnummer',
    status: 'Status',
    total: 'Gesamtsumme',
    viewOrder: 'Bestellung Anzeigen',
    trackOrder: 'Verfolgen',
  },
  habaNewsletterProcess: {
    subscription: {
      seoTitle: 'Subscribe newsletter',
      submit: 'Register now for free',
      subHeadline: 'Your selected topics',
      atLeastOne: 'Please select your desired topics.',
      submitError:
        'Sorry, unfortunately an error has occurred. Please try again later or contact our customer service.',
      submitSuccess:
        'We have sent you an email to the following address: {{email}} Please confirm your newsletter registration!',
      secondTopicHeadline: 'Room concepts, furniture systems and teaching and learning aids for',
      topics: {
        all: 'All topics',
        1: 'Crèche & Kindergarten',
        2: 'School & Afternoon Care',
        15: 'Space concepts for family friendly business premises',
        5: 'Holistic Healing: Therapy & Care on the Child',
      },
      isAgreed: {
        label:
          'I acknowledge the <a href="{{privacyUrl}}" target="_blank" rel="noopener noreferrer">Privacy Policy as well as the <a href="{{termsUrl}}" target="_blank" rel="noopener noreferrer">Terms and Conditions of Wehrfritz. By law, you have a 14-day right of withdrawal. Details and exceptions can be found in our <a href="{{cancellationUrl}}" target="_blank" rel="noopener noreferrer">Withdrawal Policy.',
        error:
          'Please confirm that you have read and accept our Terms and Conditions and Privacy Policy.',
      },
      email: {
        label: 'E-mail address',
        error: 'Please enter a valid e-mail address',
      },
    },
    unsubscribeSuccess: 'You have been successfully unsubscribed from our newsletter.',
  },
  habaBillingAddress: {
    messages: {
      success: 'Your billing address has been successfully updated',
    },
  },
  habaRegistrationBenefits: {
    title: 'Register now and benefit immediately!',
    subtitle: 'Create a customer account and immediately benefit from these advantages:',
    benefits: {
      one: 'Pay by invoice',
      two: 'View delivery status and entire order history',
      three: 'Create multiple wishlists',
      four: 'Manage different delivery and billing addresses',
      five: 'Request non-binding, customized preliminary quotes',
    },
  },
  habaChat: {
    iconName: 'You',
  }
};
